module.exports = __webpack_public_path__ + "assets/33edd4208d2ff5a739a4ddc32be05d6d.jpg";